var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#BAE4CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 8.50241C15.4286 10.4367 13.8935 12.0048 12 12.0048C10.1065 12.0048 8.57143 10.4367 8.57143 8.50241C8.57143 6.56808 10.1065 5 12 5C13.8935 5 15.4286 6.56808 15.4286 8.50241Z",
    fill: "#1F9A4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7464C7.62147 13.7464 6.23849 16.6607 6.02938 18.5018C5.99822 18.7761 6.22386 19 6.5 19H17.5C17.7761 19 18.0018 18.7761 17.9706 18.5018C17.7615 16.6607 16.3785 13.7464 12 13.7464Z",
    fill: "#1F9A4F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGreen);
export default __webpack_public_path__ + "static/media/user-green.c116dcb28b1147edc2cc6623ab7dc8fe.svg";
export { ForwardRef as ReactComponent };